import React from 'react';
import { CORTAD_VARIABLES } from 'utils/cortadLayers';
import './CortadTimeline.css';

const CortadLegend = ({ variable = 'tsa_dhw', meta }) => {
  const spec = CORTAD_VARIABLES.find((item) => item.id === variable) || CORTAD_VARIABLES[3];
  const info = meta?.variables?.[variable] || {};
  const min = info.vmin ?? 0;
  const max = info.vmax ?? 16;
  const barClass = variable === 'sst' ? 'is-sst' : variable === 'ssta' ? 'is-ssta' : '';
  return (
    <div className="cortad-legend">
      <div className="cortad-legend-title">{spec.label}</div>
      <div className={`cortad-legend-bar ${barClass}`} />
      <div className="cortad-legend-scale">
        <span>{min}{spec.unit === '°C-weeks' ? '' : spec.unit}</span>
        <span>{max} {spec.unit}</span>
      </div>
    </div>
  );
};

export default CortadLegend;
